module.exports = __webpack_public_path__ + "img/mico-group.ade0b3d1.jpg";